import styled from 'styled-components';

/**
 * Desktop: a row under the TableHeader, its gap and padding matching it so
 * the columns line up. Phone: the cells hide and the row holds the phone
 * card instead.
 */
export const PlayerRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.mediumGray};
  font-variant-numeric: tabular-nums;

  @media (max-width: 800px) {
    display: block;
    padding: 16px 0;
  }
`;

/** One column of a desktop row, as wide as its header. */
export const Cell = styled.div<{ $width: string }>`
  width: ${({ $width }) => $width};
  min-width: 0;

  @media (max-width: 800px) {
    display: none;
  }
`;

/** The player's name, phone and the Banned tag, wrapping on a phone. */
export const NameLine = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 8px;
`;
